import React from "react"
import ButtonBase from "@material-ui/core/ButtonBase"
import {makeStyles} from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import {nl2br} from "../common"
import {useTranslation} from "react-i18next"
import "../i18n"
import {useMemo} from "react"

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6.3),
    textAlign: `center`,
    width: `100%`,
  },
  image: {
    position: `relative`,
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(0.6),
    marginBottom: theme.spacing(0),
    marginLeft: theme.spacing(0.6),
    height: 300,
    [theme.breakpoints.down(`sm`)]: {
      width: `100% !important`,
      height: 200,
      marginRight: theme.spacing(0),
      marginLeft: theme.spacing(0),
    },
    "&:hover, &$focusVisible": {
      zIndex: 1,
      "& $imageBackdrop": {
        opacity: 0.1,
      },
      "& $imageMarked": {
        opacity: 0,
      },
      "& $imageTitle": {
        border: `10px solid currentColor`,
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: `absolute`,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: `absolute`,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: `cover`,
    backgroundPosition: `center 40%`,
  },
  imageBackdrop: {
    position: `absolute`,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create(`opacity`),
  },
  imageTitle: {
    position: `relative`,
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
    fontSize: 44,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: `absolute`,
    bottom: -2,
    left: `calc(50% - 9px)`,
    transition: theme.transitions.create(`opacity`),
  },
  label: {
    fontSize: 32,
    whiteSpace: `preLine`,
    [theme.breakpoints.down(`sm`)]: {
      fontSize: 28,
    },
  },
}))

export default function InformationPage({browser}) {
  const {t} = useTranslation()
  const classes = useStyles()
  return useMemo(() => {
    const images = [
      {
        url: `images/chrome.png`,
        title: `Google Chrome`,
        width: `20%`,
        href: `https://www.google.com/chrome/`,
      },
      {
        url: `images/firefox.png`,
        title: `Firefox`,
        width: `20%`,
        href: `https://www.mozilla.org/`,
      },
      {
        url: `images/safari.png`,
        title: `Safari`,
        width: `20%`,
        href: `https://support.apple.com/downloads/safari/`,
      },
      {
        url: `images/edge.png`,
        title: `Microsoft Edge`,
        width: `20%`,
        href: `https://www.microsoft.com/edge/`,
      },
    ]
    return (
      <div className={classes.root}>
        <div>
          <h1 className={classes.label}>{nl2br(browser + t(`ie-message`))}</h1>
        </div>
        {images.map((image) => (
          <ButtonBase
            focusRipple
            key={image.title}
            className={classes.image}
            focusVisibleClassName={classes.focusVisible}
            style={{
              width: image.width,
            }}
            target="_blank"
            href={image.href}
          >
            <span
              className={classes.imageSrc}
              style={{
                backgroundImage: `url(${image.url})`,
              }}
            />
            <span className={classes.imageBackdrop} />
            <span className={classes.imageButton}>
              <Typography component="span" variant="subtitle1" color="inherit" className={classes.imageTitle}>
                {image.title}
                <span className={classes.imageMarked} />
              </Typography>
            </span>
          </ButtonBase>
        ))}
      </div>
    )
  }, [classes, browser])
}
